<template>
  <component :is="type" :to="to" :href="href" class="button">
    <svg
      v-if="!full"
      width="39"
      height="25"
      viewBox="0 0 39 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="logo"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M0.976316 7.00547C0.941335 6.00374 0.917134 5.29496 0.943056 4.73929C0.968591 4.19189 1.0414 3.85577 1.16568 3.58926C1.41827 3.04758 1.83586 2.59977 2.3586 2.31001C2.61579 2.16744 2.94602 2.07136 3.4903 2.0077C4.04281 1.94308 4.75155 1.91778 5.75328 1.8828L32.1523 0.960928C33.154 0.925947 33.8628 0.901747 34.4185 0.927669C34.9659 0.953204 35.302 1.02602 35.5685 1.15029C36.1102 1.40288 36.558 1.82047 36.8477 2.34321C36.9903 2.6004 37.0864 2.93063 37.15 3.47491C37.2147 4.02742 37.24 4.73617 37.2749 5.73789L37.703 17.9946C37.7379 18.9963 37.7621 19.7051 37.7362 20.2608C37.7107 20.8081 37.6379 21.1443 37.5136 21.4108C37.261 21.9525 36.8434 22.4003 36.3207 22.69C36.0635 22.8326 35.7333 22.9287 35.189 22.9923C34.6365 23.057 33.9277 23.0823 32.926 23.1172L6.52699 24.0391C5.52527 24.0741 4.81648 24.0983 4.26081 24.0724C3.71342 24.0468 3.37729 23.974 3.11078 23.8497C2.5691 23.5972 2.12129 23.1796 1.83153 22.6568C1.68897 22.3996 1.59289 22.0694 1.52923 21.5251C1.46461 20.9726 1.43931 20.2639 1.40433 19.2621L0.976316 7.00547Z"
          fill="white"
          stroke="#6574CD"
          stroke-width="1.41509"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="39"
          height="25"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.34451 23.7024L33.9255 22.6694C35.8782 22.6012 37.4058 20.963 37.3376 19.0103L36.8417 4.80907C36.7735 2.85643 35.1353 1.32878 33.1827 1.39696L4.88584 2.38511C2.93319 2.4533 1.40553 4.09151 1.47372 6.04416L1.98816 20.7757"
            fill="white"
          />
          <path
            d="M4.3445 23.7024L26.8249 22.9173C32.6991 22.7122 37.2948 17.7839 37.0897 11.9097V11.9097C36.8846 6.03549 31.9563 1.43979 26.0821 1.64492L19.0343 1.89104C9.26765 2.23209 1.62674 10.426 1.96779 20.1926L1.98816 20.7757"
            stroke="white"
            stroke-width="1.41509"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M0.0334473 7.03839C0.0334473 7.03839 12.5934 16.8655 19.4562 16.6258C26.3191 16.3862 38.1629 5.70688 38.1629 5.70688"
            stroke="#6574CD"
            stroke-opacity="0.8"
            stroke-width="1.41509"
          />
          <path
            fill-rule="evenodd"
            class="dot-3"
            clip-rule="evenodd"
            d="M23.0807 8.12149C23.0466 7.14517 23.8104 6.32606 24.7867 6.29197C25.763 6.25787 26.5821 7.0217 26.6162 7.99802C26.6503 8.97435 25.8865 9.79345 24.9102 9.82755C23.9339 9.86164 23.1147 9.09781 23.0807 8.12149Z"
            fill="#F2AC79"
            fill-opacity="0.8"
          />
          <path
            fill-rule="evenodd"
            class="dot-2"
            clip-rule="evenodd"
            d="M17.188 8.32724C17.1539 7.35092 17.9177 6.53181 18.894 6.49772C19.8703 6.46362 20.6894 7.22745 20.7235 8.20377C20.7576 9.1801 19.9938 9.9992 19.0175 10.0333C18.0412 10.0674 17.222 9.30356 17.188 8.32724Z"
            fill="#F2AC79"
            fill-opacity="0.8"
          />
          <path
            fill-rule="evenodd"
            class="dot-1"
            clip-rule="evenodd"
            d="M11.2954 8.53305C11.2613 7.55673 12.0251 6.73762 13.0014 6.70353C13.9778 6.66943 14.7969 7.43326 14.831 8.40958C14.865 9.38591 14.1012 10.205 13.1249 10.2391C12.1486 10.2732 11.3295 9.50937 11.2954 8.53305Z"
            fill="#F2AC79"
            fill-opacity="0.8"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="38.6792" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <img
      v-if="full"
      src="../../assets/icons/promo-full.svg"
      class="logo"
      alt="promo.ai"
    />
  </component>
</template>

<script>
export default {
  name: "PromoLogo",
  props: {
    to: { default: "", type: String },
    href: { default: "", type: String },
    full: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    type() {
      if (this.to) {
        return "router-link";
      }

      if (this.href) {
        return "a";
      }

      return "div";
    },
  },
};
</script>

<style scoped>
.button {
  @apply p-0 m-0 leading-none;
}

.logo {
  @apply m-0;
}
</style>
